<script lang="ts">
  // props
  export let highlightErrors: boolean;
  export let authStatus;
</script>

<div
  style="flex-wrap: nowrap;"
  class="fizz-stack-12 fizz-alert--small"
  class:fizz-alert-warning={!highlightErrors}
  class:fizz-alert-error={highlightErrors}
  data-testid="cart-requires-retailer-auth"
>
  {#if authStatus == "invalid"}
    <p class="fizz-text-small">
      <slot name="invalid-description" />
    </p>
    <div class="fizz--alert-links">
      <div class="fizz-flex-row">
        <slot name="invalid-buttons" />
      </div>
    </div>
  {:else if authStatus == "pending"}
    <p class="fizz-text-small">
      <span class="fizz-text-strong"><slot name="pending-title" /></span>
      <slot name="pending-description" />
    </p>
    <div class="fizz--alert-links">
      <div class="fizz-flex-row">
        <slot name="pending-buttons" />
      </div>
    </div>
  {/if}
</div>
